import { Actions, ActionTypes } from './actions';
import { Discount, Campaign } from '../../types/discounts';

interface Asset {
    discountId: string;
    publicUrl: string;
}

export interface State {
    isLoading: boolean;
    error: boolean;
    discounts: Discount[];
    campaign: Campaign | undefined;
    assets?: Asset[];
}

export const initialState: State = {
    isLoading: false,
    error: false,
    discounts: [],
    campaign: undefined,
    assets: [],
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.FetchCampaign:
            return {
                ...state,
                campaign: undefined,
                isLoading: true,
            };

        case ActionTypes.FetchCampaignResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                campaign: action.payload,
            };

        case ActionTypes.FetchDiscounts:
            return {
                ...state,
                discounts: [],
                isLoading: true,
            };

        case ActionTypes.FetchDiscountsResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                discounts: action.payload,
                assets: action.payload.reduce<Asset[]>(
                    (assets, discount) => [
                        ...assets,
                        ...(discount.links || [])
                            .filter((link) => link.rel === 'thumbnail_discount_image')
                            .map((link) => ({
                                discountId: discount.id || '',
                                publicUrl: link.href,
                            })),
                    ],
                    []
                ),
            };

        case ActionTypes.ClearFetchedData:
            return {
                isLoading: false,
                error: false,
                discounts: [],
                campaign: undefined,
            };

        case ActionTypes.UpdateCampaign:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.UpdateCampaignResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        case ActionTypes.UpdateDiscount:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.UpdateDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        case ActionTypes.CreateDiscount:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.CreateDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        case ActionTypes.DeleteDiscount:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.DeleteDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        default:
            return state;
    }
}
